import DOMPurify from 'dompurify';

const RichTextDisplay = ({ content, className = '' }) => {
  if (!content) return null;

  return (
    <div
      className={`prose max-w-none prose-p:leading-[1.2] prose-li:leading-[1.2] ${className}`}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
    />
  );
};

export default RichTextDisplay;